import { Button, Chip, Link, Typography, Divider, Grid } from '@mui/material';
import { RichTextContent } from 'components/RichTextContent';
import { BroadcastifyFeed } from 'features/broadcastify/broadcastify.types';
import { useTranslation } from 'react-i18next';
import { useReleaseFlag } from 'hooks/useReleaseFlags';

type BroadcastifyFeedDetailsProps = BroadcastifyFeed;

export const BroadcastifyFeedDetails = (
  props: BroadcastifyFeedDetailsProps,
): JSX.Element => {
  const { name, description, listeners, online, listenUrl } = props;
  const { t } = useTranslation();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');

  return (
    <Grid container spacing={2}>
      <Grid size={12} container spacing={2}>
        <Grid size={12}>
          <Typography variant="h3" sx={{ fontWeight: 'fontWeightBold' }}>
            {name}
          </Typography>

          <Chip
            label={`${listeners} listeners`}
            variant="watchduty"
            color={online ? 'success' : 'error'}
            sx={{ mt: 0.5 }}
          />
        </Grid>

        <Grid size={12}>
          <Button
            size="large"
            fullWidth
            component={Link}
            href={listenUrl}
            target="_blank"
          >
            {pinImprovements
              ? t('feeds.openFeed')
              : t('broadcastifyFeed.openFeed')}
          </Button>
        </Grid>
      </Grid>

      {description && (
        <>
          <Grid size={12}>
            <Typography variant="h3" sx={{ mt: 2 }}>
              {t('broadcastifyFeed.information')}
            </Typography>
          </Grid>

          <Grid
            size={12}
            sx={(theme) => ({
              mx: { xs: `-${theme.spacing(2)}` },
              width: { xs: `calc(100% + ${theme.spacing(4)})` },
            })}
          >
            <Divider />
          </Grid>

          <Grid size={12}>
            <RichTextContent content={description} />
          </Grid>
        </>
      )}
    </Grid>
  );
};
